import SecondaryNavigationItem from './secondaryNavigationItem.js';
export default SecondaryNavigationItem;
